import { localized } from "@msuite/ui/localization";
import { createColumnHelper } from "@msuite/ui/table";
import { Tag } from "@msuite/ui/tag";
import { moment } from "@msuite/utils/date";
import { getReturnOrderNumberString, getReturnOrderStateColor } from "@msuite/utils/stock";
import { guardArray } from "@msuite/utils/array";
import { guardString } from "@msuite/utils/strings";
import type { ReturnOrderListItem } from "@msuite/utils/types";

const columnHelper = createColumnHelper<ReturnOrderListItem>();

export const returnOrdersTableColumns = [
	columnHelper.accessor("number", {
		id: "number",
		header: localized("stock.return_order_no"),
		cell: (cell) => getReturnOrderNumberString(cell.getValue()),
	}),
	columnHelper.accessor("projectName", {
		id: "projectName",
		header: localized("projects.project"),
		cell: (cell) => guardString(cell.getValue()),
	}),
	columnHelper.accessor("projectNumber", {
		id: "projectNumber",
		header: localized("projects.fields.project_number"),
		cell: (cell) => guardString(cell.getValue()),
	}),
	// The trucks read as a plate list rather than a count: a yard recognises "HRO-RT 1", not "2".
	columnHelper.accessor(
		(row) =>
			guardArray(row.vehicles)
				.map((v) => v.licensePlate)
				.join(", "),
		{
			id: "vehicles",
			header: localized("stock.return_vehicles"),
			cell: (cell) => cell.getValue() || localized("stock.return_vehicles_none"),
		},
	),
	columnHelper.accessor("bookedArticleLines", {
		id: "bookedArticleLines",
		header: localized("stock.return_booked"),
		cell: (cell) => String(cell.getValue() ?? 0),
	}),
	columnHelper.accessor("createdAt", {
		id: "createdAt",
		header: localized("general_fields.created_at"),
		cell: (cell) => moment(cell.getValue()).shortFormat(),
	}),
	columnHelper.accessor("state", {
		id: "state",
		header: localized("general.state"),
		cell: (cell) => (
			<Tag
				color={getReturnOrderStateColor(cell.getValue())}
				variant="plain"
				withPing={cell.getValue() === "in-progress"}
				className="-mx-2 px-2"
			>
				{localized(`stock.return_order_state.${cell.getValue()}`)}
			</Tag>
		),
	}),
];
